import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ROUTE_PATH } from '@core/constants/route-path';
import { SessionContextService } from '@core/services/common';
import { DialogTemplate } from '@core/models/models';
import { Subscription } from 'rxjs';
import { ProcessLoadingStackService, ProcessLoadingService } from '../../../core/services/common'
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { DpadZoneType } from '@core/constants';

@Component({
  selector: 'caremoni-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent  implements OnInit, OnDestroy {
  isLoggedIn = false;
  subscriptions: Subscription[] = [];
  @Output() logoutHandler = new EventEmitter<any>();
  modalLogout = new DialogTemplate();
  isShowDlgLogOut: boolean = false;
  ROUTE_PATH = ROUTE_PATH;
  userName: string = "";
  DpadZoneType = DpadZoneType;

  constructor(
    private processLoadingStackService: ProcessLoadingStackService,
    private processLoadingService: ProcessLoadingService,
    private sessionContextService: SessionContextService,
    private dpadControlService: DpadControlService,
  ) {
  }
  
  ngOnInit(): void {
    let userInfo = this.sessionContextService.getStaffInfo<any>();
    this.userName = userInfo?.family + " " + userInfo?.given;
    
    this.modalLogout.isShowHeader = false;
    // kiểm tra nếu click ra ngoài phạm vi dialog logout và avatar thì đóng dialog
    window.addEventListener('click', (event: any) => {
      let logoutDlg = document.getElementById('dlgLogOut');
      if (!logoutDlg?.contains(event.target)) {
        let avatar = document.getElementById('hdavatar');
        if (!avatar?.contains(event.target))  this.isShowDlgLogOut = false;
      }
      else this.isShowDlgLogOut = false;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  openLogOutDialog() {
    this.dpadControlService.openDialog();
    this.dpadControlService.setOnBackDPad(() => {
      this.isShowDlgLogOut = false;
      this.dpadControlService.onBackDPad();
    });

    this.isShowDlgLogOut = true;
  }

  // logout
  logout(isLogout: boolean) {
   
    if(isLogout) {
      this.logoutHandler.emit();
    }
  }

}
